<template>
<AppDialog :is-open="isDialogOpened"
           size="l"
           :ok-text="$t('common.confirm')"
           @ok="confirm"
           @cancel="closeDialog"
>
  <template #title>{{ $t('project.checklist.dialogs.ChecklistStatusDialogCloseConfirmation.dialogTitle') }}</template>
  <template #body>
    <v-row>
      <v-col class="text--primary">
        {{ $t('project.checklist.dialogs.ChecklistStatusDialogCloseConfirmation.dialogText') }}
      </v-col>
    </v-row>
  </template>
</AppDialog>
</template>

<script>
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'ChecklistStatusDialogCloseConfirmation',
  components: { AppDialog },
  emits: ['confirm'],
  mixins: [dialogMixin],
  methods: {
    confirm () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
